var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dmo-menu"},_vm._l((_vm.modes),function(item){return _c('li',{key:item.key,class:{'active': _vm.activeMode === item},on:{"click":function($event){_vm.select(item)}}},[_c('a',{attrs:{"href":"#"}},[_vm._v(_vm._s(item.text))])])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-058f26a6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = 49
// module chunks = 164